const tableTitleExpiredServices = {
  title: 'Serviços Atrasados',
  placeholder: 'Pesquisar',
};

export default tableTitleExpiredServices;
